// npm packages
import React, { useEffect, useContext, useState, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as moment from "moment";
import { useTranslation } from 'react-i18next';

// custom pages
import Context from "context/context";
import Table from "components/Table/Table";
import useDebounce from "helpers/useDebounce";
import "./Privilege.css";
import { privilegeStyles } from "./styles";
import privilegeApi from "apis/privilege/privilege";
import Loader from "components/Loader/Loader";
import searchIcon from "assets/img/Search_Icon.png";
//US
import Gold from "assets/img/Gold_wword_Gold.png";
import Silver from "assets/img/Silver_wword_Silver.png";
import Platinum from "assets/img/Platinum_wword_Platinum.png";
import Bronze from "assets/img/BronzeFuschia_wwords_Bronze.png";
// Canada
import GoldCA from 'assets/img/gold-level.png';
import SilverCA from 'assets/img/silver-level.png';
import PlatinumCA from 'assets/img/platinum-level.png';
import BronzeCA from 'assets/img/bronze-level.png';

import audit from "apis/audit/audit";
import access, { loyalty } from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

// material-ui icons
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";

import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";

//Helpers
import { blockInvalidChar } from "helpers/blockInvalidChar";
import { dateFormat } from "helpers/dataFormat"
import { imageHandler } from 'helpers/imageHandler';
import { CSVLink } from 'react-csv';
import { exportcontractHeaders } from "./export";


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
        marginTop: 0,
      },
    },
  },
})(TextField);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Privilege(props) {
  const { state, dispatch } = useContext(Context);
  const { getShipto, searchShipto, updateShipto, getPrivilegeCodes, handlecontractExport } =
    privilegeApi();
  const { getAudit, getAuditTableConfig } = audit();

  const history = useHistory();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const [customerData, setCustomerData] = useState([]);
  const [customerDataClone, setCustomerDataClone] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const classes = privilegeStyles();
  const [fillter, setfillter] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [loyaltyAccount, setLoyaltyAccount] = useState(
    location?.state?.data || []
  );
  const [response, setResponse] = useState(false);
  const [privilegeCodes, setPrivilegeCodes] = useState({});
  const [privilegeCodesArray, setPrivilegeCodesArray] = useState({});
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [privilege_flag, setPrivilege_flag] = useState(false)
  const [exportData, setExportData] = useState([]);
  const [IsLoading, setIsLoading] = useState();

  const [states, setstates] = useState({
    historyDialog: false,
    historyData: [],
    historyLoader: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  const handlePagination = (value) => {
    setOffset(value);
  };

  const toastCss = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  };

  // browser back button action logic
  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        history.push({
          pathname: "/dashboard/privilege",
          searchValue: location?.state?.search,
        });
      }
    };
  }, [history]);

  useEffect(() => {
    if (Object.keys(loyaltyAccount).length > 0) handleGetPrivilegeCodes();
  }, [loyaltyAccount]);

  // const handleGetPrivilegeCodes = async () => {
  //   try {
  //     let tier = loyaltyAccount?.tier;
  //     let res = await getPrivilegeCodes(tier);
  //     if (res && res?.data.length > 0) {
  //       let obj = {};
  //       res.data.map((d) => {
  //         if (d?.privilege_type !== "X Code" ||  state?.userInfo?.role_id == 10 ||state?.userInfo?.role_id == 13)
  //         if(state?.userInfo?.loyalty_organization_name === "Henry Schein Canada" && (d?.privilege_type !== "X Code"||  state?.userInfo?.role_id == 10) ){
  //           obj = {
  //             ...obj,
  //             [d.privilege_type]: [...(obj[d.privilege_type] || []), d],
  //           }
  //         }else {
  //           if(d?.privilege_type !== "S Code"  || state?.userInfo?.role_id == 10 ||state?.userInfo?.role_id == 13 ||
  //            state?.userInfo?.role_id == 3)             
  //            {
  //             obj = {
  //               ...obj,
  //               [d.privilege_type]: [...(obj[d.privilege_type] || []), d],
  //             };
  //           }
            
  //         }
            
  //       });

  //       setPrivilegeCodes(obj);
  //       setPrivilegeCodesArray(res.data);
  //     }
  //   } catch (e) {
  //     console.log({ e });
  //   }
  // };
  const handleGetPrivilegeCodes = async () => {
    try {
      let tier = loyaltyAccount?.tier;
      let res = await getPrivilegeCodes(tier);
  
      if (res && res?.data.length > 0) {
        let obj = {};
  
        res.data.map((d) => {
          // Restrict S Code for super admin (role_id 13)
          if (d?.privilege_type === "S Code" && state?.userInfo?.role_id === 13) return;
  
          if (d?.privilege_type !== "X Code" || state?.userInfo?.role_id == 10 || state?.userInfo?.role_id == 13) {
            if (
              state?.userInfo?.loyalty_organization_name === "Henry Schein Canada" &&
              (d?.privilege_type !== "X Code" || state?.userInfo?.role_id == 10)
            ) {
              obj = {
                ...obj,
                [d.privilege_type]: [...(obj[d.privilege_type] || []), d],
              };
            } else {
              if (d?.privilege_type !== "S Code" || state?.userInfo?.role_id == 10) {
                obj = {
                  ...obj,
                  [d.privilege_type]: [...(obj[d.privilege_type] || []), d],
                };
              }
            }
          }
        });
  
        setPrivilegeCodes(obj);
        setPrivilegeCodesArray(res.data);
      }
    } catch (e) {
      console.log({ e });
    }
  };
  
  useEffect(() => {
    if (state.userInfo && Object.keys(state.userInfo).length > 0) {
      if (loyaltyAccount) {
        searchValue.length > 0 ? getSearch() : getCustomer();
      } else {
        history.goBack();
      }
      dispatch({ type: "SET_SIDEBAR", payload: true });
    }
    // getuser(values);
  }, [state.userInfo, offset]);

  useEffect(() => {
    if (searchBounceValues && searchBounceValues.length > 0) {
      if (loyaltyAccount) {
        getSearch();
      } else {
        setOffset(1);
      }
    }
  }, [searchBounceValues]);

  async function getCustomer() {
    try {
      let pagination = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      setResponse(false);
      let res = await getShipto(loyaltyAccount.loyalty_id, pagination);
      if (res) {
        if (res.data && res.count) {
          setCount(res.count);
          setCustomerData(
            res.data.map((d) => {
              return {
                ...d,
                selected: false,
                valid: true,
                errorText: "",
                response_time: "",
              };
            })
          );
          setCustomerDataClone(
            res.data.map((d) => {
              return {
                ...d,
                selected: false,
                valid: true,
                errorText: "",
                response_time: "",
              };
            })
          );
          setResponse(true);
        }
        setResponse(true);
      }
    } catch (e) {
      console.log({ e });
    }
  }

  async function getSearch() {
    try {
      let values = {
        loyalty_id: loyaltyAccount.loyalty_id,
        searchBounceValues: searchBounceValues,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      setResponse(false);
      let res = await searchShipto(values);
      if (res?.data && res?.count) {
        setCount(res.count);
        setCustomerData(
          res.data.map((d) => {
            return {
              ...d,
              selected: false,
              valid: true,
              errorText: "",
              response_time: "",
            };
          })
        );
        setCustomerDataClone(
          res.data.map((d) => {
            return {
              ...d,
              selected: false,
              valid: true,
              errorText: "",
              response_time: "",
            };
          })
        );
        setResponse(true);
      } else {
        setCustomerData([]);
      }
      setResponse(true);
    } catch (error) {
      console.log(error);
    }
  }

  const handleChecked = (event, values, i) => {
    let checked = event.target.checked;
    setCustomerData(
      customerData.map((customer) => {
        if (
          customer.customer_account_number == values.customer_account_number
        ) {
          customer.selected = checked;
          if (customer.selected == false) {
            customer.valid = true;
            customer.errorText = "";
          }
        }
        return customer;
      })
    );
    if (!checked) {
      setCustomerData([
        ...customerData.slice(0, i),
        { ...customerDataClone[i] },
        ...customerData.slice(i + 1),
      ]);
    }
  };

  async function handleAssignClick(values) {
    let error = false;
    console.log(customerData, "customerData")
    setCustomerData(
      customerData.map((item) => {
        if (item.selected) {
          if (
            !item.privilege_code_updated &&
            !item.privilege_set_flag_updated
          ) {
            item.valid = false;
            error = true;
            setErrorText("Please update any fields");
            setPopUpOpen(true);
          }
          else {
            item.valid = true;
          }
        } else {
          item.valid = true;
        }
        return item;
      })
    );

    if (!loyaltyAccount.is_active) {
      toast.error(
        "Please activate loyalty account before assign privilege code",
        toastCss
      );
      return;
    }
    if (!error) {
      let selectedCustomer = customerData.filter((item) => item.selected);
     
        
      if (selectedCustomer.length == 0) {
        setErrorText("Please select the customer account");
        setPopUpOpen(true);
        return;
      }
      let dormantFlag=loyaltyAccount?.dormant_account_flag ===true;
      let dormantProcessed=loyaltyAccount?.dormant_processed ===true;
      // let signatureFlag=loyaltyAccount?.signature_flag === true;
      // if(signatureFlag === true)
      // {
      //   toast.error("Privilege Code cannot be updated for Signature customers.");
      //   return;
      // }
      if(dormantFlag ===true && dormantProcessed === true)
      {
        toast.error("Privilege Code cannot be updated for dormant customers. Reactivate their account in the 'Manage My Account' screen to proceed further.");
        return;
      }
      if(dormantFlag === true && dormantProcessed === false)
        {
          toast.error("Privilege Code cannot be updated for Non Earning customers.");
          return;
        }
       // let selectedCustomer = customerData.filter((item) => item.selected);
       
        if (selectedCustomer.some((item) => item.signature_flag === true)) {
          toast.error("Privilege Code cannot be updated for Signature customers.");
          return;
        }
        if (
          selectedCustomer.some(
            item => item["Loyalty_Subscription_Mapping.is_active"] === true
          )
        ) {
          toast.error("Privilege Code cannot be updated for Startup customers.");
          return;
        }
        
      else {
        selectedCustomer.map((item) => {
          let code_assignment = "";

          if (item.code_assignment == "New" || item.code_assignment == "") {
            code_assignment = "Assigned";
          } else if (item.code_assignment == "Assigned") {
            code_assignment = "Updated";
          } else if (item.code_assignment == "Updated") {
            code_assignment = "Updated";
          }

          item["code_assignment"] = code_assignment;
        });

        let res = await updateShipto({
          selectedCustomer: selectedCustomer,
          loyaltyAccount: loyaltyAccount,
        });
        
        if (res && res.type == "success") {
          let arr = [];
          customerData.map(
            (c) =>
            (arr = [
              ...arr,
              {
                ...c,
                privilege_code_updated: false,
                privilege_code_updated_value: "",
                privilege_set_flag_updated: false,
                privilege_set_flag_updated_value: "",
                selected: false,
              },
            ])
          );
          setCustomerData(arr);
          history.push("/dashboard/upload-success", {
            type: "Privilege data is uploaded to our system successfully.",
          });
        }
      }
    }
  }

  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        key: "laf",
      };
      let res = await getAudit(values);
      //console.log({ res });
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleExport = async () => {
    setIsLoading(true)
   
    let values;
    values = {
        searchValue:loyaltyAccount.loyalty_id,

        
    };

    dispatch({ type: "SET_LOADING", payload: true });
    let res = await handlecontractExport(values);
  
    if (res && res.data) {
        setIsLoading(false);
        setExportData(res.data);
        dispatch({ type: "SET_LOADING", payload: false });
       
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return false;
        }
       
        return true;
      }
    }
  const org = state?.userInfo?.loyalty_organization_name;

  console.log({loyaltyAccount});
  

  return (
    <React.Fragment>
      <Grid
        style={{
          width: "100%",
          height: 50,
          backgroundColor: "#2F7CBD",
          marginBottom: 10,
        }}
      >
        <Grid
          xs={12}
          sm={12}
          lg={12}
          style={{
            color: "#fff",
            fontSize: 22,
            display: "flex",
            alignItems: "center",
          }}
        >
          <ArrowBackOutlinedIcon
            style={{
              fontSize: 22,
              margin: "10px 10px 10px 10px",
              cursor: "pointer",
            }}
            onClick={() => {
              history.push({
                pathname: "/dashboard/privilege",
                searchValue: location?.state?.search,
              });
            }}
          />
          <span>{t('Setup Privilege Code')}</span>
        </Grid>
      </Grid>
      <div className="container">
        <Grid container spacing={0} style={{ margin: "10px 10px 10px 10px" }}>
          <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>{t('Loyalty Id')} </div>
              <div style={{ color: "#000000", fontSize: 16 }}>
                {loyaltyAccount?.loyalty_id}
              </div>
            </div>
          </Grid>
          <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>
                {t('Date of Enrollment')}{" "}
              </div>
              <div style={{ color: "#000000", fontSize: 16 }}>
                {dateFormat(loyaltyAccount?.created_at, i18n.language)}
              </div>
            </div>
          </Grid>
          <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>{t('Status')} </div>
              <div style={{ color: "#000000", fontSize: 16 }}>
                {loyaltyAccount?.is_active ? (
                  <div style={{ color: "green" }}>{t("Active")}</div>
                ) : (
                  <div style={{ color: "red" }}>Inactive</div>
                )}
              </div>
            </div>
          </Grid>
          <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>
                {t('System Managed')}{" "}
              </div>
              <div style={{ color: "#000000", fontSize: 16 }}>
                {loyaltyAccount?.system_managed
                  ? loyaltyAccount?.system_managed.charAt(0).toUpperCase() +
                  loyaltyAccount?.system_managed.slice(1).toLowerCase()
                  : "-"}
              </div>
            </div>
          </Grid>
          <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>
                {t('Sales Summary Tier')}{" "}
              </div>
              <div style={{ color: "#000000", fontSize: 16 }}>
                {t(loyaltyAccount?.sales_summary_tier)}
              </div>
            </div>
          </Grid>
          {/* <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>
                {t('Max Merch Tier')}{" "}
              </div>
              <div style={{ color: "#000000", fontSize: 16 }}>
                {t(loyaltyAccount?.max_merch_tier)}
              </div>
            </div>
          </Grid> */}
          <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>{t('Tier')} </div>
              <div style={{ color: "#000000", fontSize: 16 }}>

              {/* <div style={{background: 'lightcoral', width: 70, height: 70, borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', color: '#fff'}}>

                  {loyaltyAccount?.tier}
                  </div> */}
             
                      <img
            src={
              state?.userInfo?.loyalty_organization_name === "Henry Schein Dental"
                  ? imageHandler?.[org]?.[i18n?.language]?.[`${loyaltyAccount?.tier}SidebarLogoNew`]
                  : imageHandler?.[org]?.[i18n?.language]?.[`${loyaltyAccount?.tier}SidebarLogo`]
            }
            alt=""
            width="60px"
/>

              </div>
            </div>
          </Grid>
          <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>
                {t('Tier Overwrite Reason')}{" "}
              </div>
              <div style={{ color: "#000000", fontSize: 16 }}>
                {t(loyaltyAccount?.override_reason)}
              </div>
            </div>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={0}>
          <Grid item xs={12} lg={7}>
            <CssTextField
              placeholder={t("Search for Customer Account Number")}
              type={"number"}
              onWheel={(e) => e.target.blur()}
              variant="outlined"
              className={classes.searchInput}
              onKeyDown={blockInvalidChar}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        className={classes.searchInputIcon}
                        onClick={() => {
                          setSearchValue("");
                          setOffset(1);
                          getCustomer();
                        }}
                      />
                    ) : (
                      <img
                        src={searchIcon}
                        width="20px"
                        alt=""
                        className={classes.searchInputIcon}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setOffset(1);
                if (e.target.value.length == 0) {
                  getCustomer();
                }
              }}
              onClick={() => {
                if (searchValue.length == 0) {
                  setOffset(1);
                }
              }}
            />
          </Grid>

          {loyaltyAccount?.is_active && (
            <Grid
              onClick={() => {
                fillter && setfillter(false);
              }}
              item
              xs={12}
              lg={5}
              style={{ textAlign: "right", alignSelf: "center" }}
            >
              
              {
  (state?.userInfo?.role_id === 10 || state?.userInfo?.role_id === 13 || state?.userInfo?.role_id === 3)
  ? (
  <Button
    variant="contained"
    color="primary"
    onClick={() => {
      if (state?.userInfo?.editAction) {
        handleAssignClick();
      } else {
        toast.error(state.userInfo?.editAccess);
      }
    }}
    style={{ float: "right" }}
    className="dash-1-filter-btn"
    disabled={customerData.length === 0}
  >
    {t('Assign')}
  </Button>
) : null}

             
               <CSVLink
            id="csv"
            data={exportData}
            headers={exportcontractHeaders}
            filename={
              `contract-code_audit` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
          {org == "Henry Schein Canada"? (
          
                <>
              <button
            disabled={IsLoading}
            className={classes.contractexport}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export Code Changes')}
          </button>
          </>
          ):
          <></>
}
            </Grid>
          )}

         
             
        </Grid>
        <div style={{ marginTop: 26 }}>
          {response ? (
            <div>
              <div>
                <Table
                  headings={[
                   // state?.userInfo?.loyalty_organization_name !== "Henry Schein Dental" ? "" : "",
                    [ 
                      ((
                        loyaltyAccount?.is_active  &&
                        (state?.userInfo?.role_id === 10 || state?.userInfo?.role_id === 13 || state?.userInfo?.role_id === 3)
                      ) 
                      // || (
                      //   loyaltyAccount?.is_active &&
                      //   state?.userInfo?.loyalty_organization_name === "Henry Schein Canada"
                      // )
                      )
                       &&
                      (
                       // state?.userInfo?.loyalty_organization_name !== "Henry Schein Dental",
                        <Checkbox
                          color="primary"
                          onChange={(event) => {
                            let checked = event.target.checked;
                            setCustomerData(
                              customerData.map((data) => {
                                data.selected = checked;
                                return data;
                              })
                            );
                            
                            if (!checked) {
                              setCustomerData(
                                customerDataClone.map((data) => {
                                  data.selected = checked;
                                  return data;
                                })
                              );
                           
                            }
                          }}
                        />
                      ),
                    ],
                    "Ship to #",
                    "City",
                    "State",
                    "Status",
                    "Type",
                    "Code",
                    state?.userInfo?.loyalty_organization_name !== "Henry Schein Dental" ? "Contract Type" : "",
                    // "Assignment Status",
                    state?.userInfo?.auditAccess && "History",
                  ]}
                  data={customerData.map((p, i) => [
                   
                    [
                      ((
                        loyaltyAccount?.is_active &&
                        (state?.userInfo?.role_id === 10 || state?.userInfo?.role_id === 3| state?.userInfo?.role_id === 13)
                      ) 
                      // || (
                      //   loyaltyAccount?.is_active &&
                      //   state?.userInfo?.loyalty_organization_name === "Henry Schein Canada"
                      // )
                      ) && (
                        //state?.userInfo?.loyalty_organization_name !== "Henry Schein canada",
                        <Checkbox
                          key={i}
                          color="primary"
                          onChange={(event) => {
                            handleChecked(event, p, i);
                          }}
                          checked={p.selected}
                        />
                      ),
                    ],
                    p?.["customer_account_number"],
                    p?.["Customer_Account.customer_address_city_name"],
                    p?.["Customer_Account.customer_address_state_code"],
                    [
                      p?.is_active ? (
                        <div
                          style={{ color: "green" }}
                        // onClick={() => getCustomer(p)}
                        >
                          {t("Active")}
                        </div>
                      ) : (
                        <div
                          style={{ color: "red" }}
                        // onClick={() => getCustomer(p)}
                        >
                          Inactive
                        </div>
                      ),
                    ],

                    [p.selected && loyaltyAccount?.tier ? (
                        (p.privilege_type === "S Code" ) ? (
            
                          <div style={{ width: "90%"}}>
                            {p.privilege_type}
                          </div>
                        ) : (
                         
                          <TextField
                            id={`type-${i}`}
                            label="Type"
                            type="text"
                            select
                            style={{ width: "90%" }}
                            value={p.privilege_type || ""}
                            onChange={(event) => {
                              const newPrivilegeType = event.target.value;
                              let defaultPrivilegeCode = "";
                    
                              if (newPrivilegeType === "S Code") {
                                defaultPrivilegeCode = (p.signature_flag === 1 || p.signature_flag === true) ? "ST0" : "ST2";
                              } else {
                                const codes = privilegeCodes?.[newPrivilegeType]?.map(c => c.privilege_code) || [];
                                defaultPrivilegeCode = codes.length > 0 ? codes[0] : "";
                              }
                    
                              setCustomerData([
                                ...customerData.slice(0, i),
                                {
                                  ...p,
                                  privilege_type: newPrivilegeType,
                                  privilege_code: defaultPrivilegeCode,
                                  privilege_code_updated: true,
                                  privilege_code_updated_value: defaultPrivilegeCode,
                                },
                                ...customerData.slice(i + 1),
                              ]);
                            }}
                          >
                            {Object.keys(privilegeCodes).map((c) => (
                              <MenuItem key={c} value={c}>{c}</MenuItem>
                            ))}
                          </TextField>
                        )
                      ) : (
                        p?.privilege_type || "-"
                      ),
                    ],
                    // [
                    //     p.selected && privilegeCodes?.[p?.privilege_type]?.length > 1 ? (
                    //       <TextField
                    //         id={`code-${i}`}
                    //         label="Code"
                    //         type="text"
                    //         select
                    //         style={{ width: "90%" }}
                    //         value={p?.privilege_code}
                    //         onChange={(event) => {
                    //           setCustomerData([
                    //             ...customerData.slice(0, i),
                    //             {
                    //               ...p,
                    //               privilege_code: event.target.value,
                    //               privilege_code_updated: true,
                    //               privilege_code_updated_value: event.target.value
                    //             },
                    //             ...customerData.slice(i + 1),
                    //           ]);
                    //         }}
                    //       >
                            
                    //         {((p.signature_flag === true && c.privilige_type === 'S Code') ? ['ST0', 'ST1'] : ['ST2', 'ST3']).map((code) => (
                    //           <MenuItem key={code} value={code}>
                    //             {code}
                    //           </MenuItem>
                    //         ))}
                      
                            
                    //         {privilegeCodes?.[p.privilege_type]?.map((c) => (
                    //           <MenuItem key={c.privilege_code} value={c.privilege_code}>
                    //             {c.privilege_code}
                    //           </MenuItem>
                    //         ))}
                    //       </TextField>
                    //     ) : p.privilege_code ? (
                    //       p.privilege_code
                    //     ) : (
                    //       "-"
                    //     )
                                           


                    // ],
                    [
                      p.selected && privilegeCodes?.[p?.privilege_type]?.length > 1 ? (
                        <TextField
                          id={`type-${i}`}
                          label="Code"
                          type="text"
                          select
                          style={{ width: "90%" }}
                          value={p?.privilege_code}
                          onChange={(event) => {
                            setCustomerData([
                              ...customerData.slice(0, i),
                              {
                                ...p,
                                privilege_code: event.target.value,
                                privilege_code_updated: true,
                                privilege_code_updated_value: event.target.value
                              },
                              ...customerData.slice(i + 1),
                            ]);
                          }}
                        >
                          {p.privilege_type === 'S Code' ? (
                            (['ST0', 'ST1','ST2', 'ST3']).map((code) => (
                              <MenuItem key={code} value={code}>
                                {code}
                              </MenuItem>
                            ))
                          ) : (
                            privilegeCodes?.[p.privilege_type]?.map((c) => (
                              <MenuItem key={c.privilege_code} value={c.privilege_code}>
                                {c.privilege_code}
                              </MenuItem>
                            ))
                          )}
                        </TextField>
                      ) : (
                        p.privilege_code
                      )
                    ],                    
  
                     [(state.userInfo?.loyalty_organization_name !== 'Henry Schein Dental' ?
                      p?.["contract_type"] : "")],
                    // [
                    //   p.code_assignment && (
                    //     <div
                    //       key={i}
                    //       style={{
                    //         color:
                    //           (p.code_assignment == "New" && "red") ||
                    //           (p.code_assignment == "Assigned" && "Green") ||
                    //           (p.code_assignment == "Updated" && "#feb204"),
                    //       }}
                    //     >
                    //       {p.code_assignment}
                    //     </div>
                    //   ),
                    // ],
                    state?.userInfo?.auditAccess && (
                      <HistoryIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setStates({
                            historyDialog: true,
                            historyLoader: true,
                          });
                          handleGetHistoryData(p?._id);
                        }}
                      />
                    ),
                  ])}
                  offset={offset}
                  count={
                    (count / 10) % 1 == 0
                      ? Math.floor(count / 10)
                      : Math.floor(count / 10 + 1)
                  }
                  handlePagination={handlePagination}
                />
              </div>
            </div>
          ) : (
            <Loader Loading={!response} top={"15%"}></Loader>
          )}
        </div>
      </div>

      <Dialog
        open={popUpOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setPopUpOpen(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText>
            <div
              style={{ color: "#000", marginBottom: 10, fontWeight: "bold" }}
            >
              {errorText}
            </div>
            <div style={{ textAlign: "center" }}>
              <button
                className={classes.okBtn}
                onClick={() => setPopUpOpen(false)}
              >
                Ok
              </button>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {/* history */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            History{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${(d?.old_value && (d?.column_name=='Signature End Date' || d?.column_name=='Signature Start Date'))?moment(d?.old_value).format("YYYY-MM-DD"):d?.old_value}" changed to "${(d?.new_value && (d?.column_name=='Signature End Date' || d?.column_name=='Signature Start Date'))?moment(d?.new_value).format("YYYY-MM-DD"):d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
    </React.Fragment>
  );
}
